export default __webpack_public_path__ + "static/media/getBetterDealsPic.5afb78dc.svg";